import { createContext, useContext, useEffect, useState } from "react";
import { api, imgSrc } from "./api";
import { IMG } from "../data/site";

const SitePhotosContext = createContext(IMG);

export const SitePhotosProvider = ({ children }) => {
  const [photos, setPhotos] = useState(IMG);
  useEffect(() => {
    api.get("/site-photos")
      .then(({ data }) => {
        const resolved = Object.fromEntries(Object.entries(data).map(([k, v]) => [k, imgSrc(v)]));
        setPhotos({ ...IMG, ...resolved });
      })
      .catch(() => {});
  }, []);
  return <SitePhotosContext.Provider value={photos}>{children}</SitePhotosContext.Provider>;
};

export const useSitePhotos = () => useContext(SitePhotosContext);
